import React from "react";
import {
  StyledH4,
  StyledServiceStepContainer,
  StyledText,
  StyledTextContainer,
} from "./styled";
import { Button } from "antd";
import Step3 from "./Step3";
import Service from "./Step1";
import Day from "./Step2";
import Step4 from "./Step4";
import Final from "./Final";

const Body = ({ loading, data, setData, currentStep, Next }) => {
  const actualKey = Object.keys(data)[currentStep];
  const disabled =
    currentStep < 3
      ? !data[actualKey]?.length
      : !data.name.length || !data.phone.length || !data.email.length;

  const sub = `Sélectionnez-en une puis cliquez sur le bouton “CONTINUER”`;

  const steps = [
    {
      title: "Quel service recherchez-vous?",
      sub: "Vous pouvez en sélectionner plusieurs puis cliquer sur le bouton “CONTINUER”",
      content: <Service data={data} setData={setData} />,
    },
    {
      title: "Quelle est la présence souhaitée par semaine?",
      sub,
      content: <Day data={data} setData={setData} />,
    },
    {
      title: "Pour qui recherchez-vous une aide à domicile ?",
      sub,
      content: <Step3 data={data} setData={setData} />,
    },
    {
      title: "Obtenez la liste des aides à domicile",
      sub,
      content: <Step4 data={data} setData={setData} />,
    },
    {
      title: "⭐️⭐️⭐️⭐️⭐️ 4,7/5 sur Google",
      content: <Final />,
    },
  ];
  const final = currentStep === steps.length - 1;

  return (
    <StyledServiceStepContainer
      style={{
        justifyContent: final ? "start" : "space-evenly",
      }}
    >
      {!final && (
        <StyledTextContainer>
          <StyledH4>{steps[currentStep].title}</StyledH4>
          <StyledText>{steps[currentStep].sub}</StyledText>
        </StyledTextContainer>
      )}
      {steps[currentStep].content}

      {!final && (
        <Button
          style={{
            width: "12.0625rem",
            borderRadius: "0px",
            backgroundColor: `${!disabled ? "var(--pink)" : "var(--gray2)"} `,
            border: "none",
            color: `${!disabled ? "var(--white)" : "var(--light-gray2)"} `,
            display: "flex",
            alignSelf: "center",
            justifyContent: "center",
            height: 46,
            alignItems: "center",
            marginBottom: 25,
          }}
          onClick={Next}
          disabled={disabled}
          loading={loading}
        >
          CONTINUER ➜
        </Button>
      )}
    </StyledServiceStepContainer>
  );
};

export default Body;
